<template>
        <div id="graph">
            <canvas id="securityGraph" width="600" height="200"></canvas>
        </div>
       
</template>
<script>
    import axios from 'axios';
    export default {       

        props: {
            portfolioguid: String,
            codeparm: String,
            marketidparm: String,
            fromdateparm: String,
            todateparm: String
        },
        data: function () {
            return {
                portfolioGuid: this.portfolioguid,
                code: this.codeparm,
                marketId: this.marketidparm,
                fromDate: this.fromdateparm,
                toDate: this.todateparm,           
                tradesData: [],
                codeData: []
            };
        },
        methods: {
            async getTrades() {

                const { data } = await axios.get('/api/trades/GetTradesByPortfolio', {
                    params: {
                        portfolioGuid: this.portfolioGuid,
                        security: this.code,
                        marketId: this.marketId
                    }
                });

                this.tradesData = data;
            },
            async getSecurityData() {
                const { data } = await axios.get('/api/securities/GetDataByCode', {
                    params: {
                        code: this.code,
                        marketId: this.marketId,
                        fromDate: this.fromDate,
                        toDate: this.toDate
                    }
                });

                this.codeData = data; 
            },
            async getChartData() {
                console.log(this.code);                             

                await this.getTrades();
                await this.getSecurityData();

                let i = 0;
                while (i < this.codeData.length) {
                    this.codeData[i].trade = this.tradesData.filter(item => this.formatDate(item.trade_Date, "YY/MM/DD") === this.codeData[i].date)[0];

                    if (!this.codeData[i].trade) this.codeData[i].trade = {};
                    
                    i++;
                }

                var securityData = {
                    type: 'line',
                    data: {
                        labels: this.codeData.map(value => value.date),
                        datasets: [
                            { // one line graph
                                label: 'Closing Price',
                                data: this.codeData.map(value => value.close),
                                backgroundColor: ['rgba(54,73,93,.5)'],
                                borderColor: ['#36495d'],
                                borderWidth: 0.5,
                                pointStyle: 'line',
                                pointRadius: 0
                            },
                            { // one line graph
                                label: 'Orders',
                                data: this.codeData.map(value => value.trade.average_Price),
                                backgroundColor: ['rgba(54,73,93,.5)'],
                                borderColor: this.codeData.map(value => value.trade.buy_Sell == "B" ? 'green' : 'red'),
                                //borderWidth: 2,
                                //pointStyle: 'line',
                                type: 'bubble'
                                
                            }
                        ]
                    },
                    options: {
                        responsive: true,
                        lineTension: 1,
                        scales: {
                            y: {
                                ticks: {
                                    beginAtZero: false,
                                    padding: 25,
                                }
                            }
                        },
                        plugins: {
                            zoom: {
                                zoom: {
                                    wheel: {
                                        enabled: true,
                                    },
                                    pinch: {
                                        enabled: true
                                    },
                                    mode: 'xy',
                                }
                            }
                        }
                    }
                }

                this.createChart('securityGraph', securityData);
            }
        },
        async mounted() {
            await this.getChartData();
        }
    }
</script>